export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.transferId,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'text',
      value: (e) => e.baseCurrencyTitle,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Date and time',
    },
    cell: {
      type: 'slot',
      name: 'dateTime',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Receiver address',
    },
    cell: {
      type: 'slot',
      name: 'receiverAddress',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Sended funds',
    },
    cell: {
      type: 'text',
      value: (e) => e.orderCryptoAmount,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Blockchain fee',
    },
    cell: {
      type: 'text',
      value: (e) => e.blockchainFee,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Order ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.orderId,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Deposited funds',
    },
    cell: {
      type: 'text',
      value: (e) => e.orderFiatEnteredAmount,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Transaction Hash',
    },
    cell: {
      type: 'slot',
      name: 'transactionHash',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
];
